<template>

    <el-upload
      class="avatar-uploader upload"
      :action="imgurl()"
      list-type="picture-card"
      :show-file-list="false"
      :on-success="handleSuccess"
      :before-upload="beforeAvatarUpload"
      :headers="headers"
    >
      <img v-if="imagesUrl" :src="imagesUrl" class="avatar" />
<!--      <img v-else :src="loadImage('/cliupdata.png')" style="width:160px" />-->
      <div   v-else class="bg" >
        <img v-if="type==2" :src="require('@/assets/v2/idcard-1.png')" class="bg-image">
        <img v-if="type==3" :src="require('@/assets/v2/idcard-2.png')" class="bg-image">
        <img :src="require('@/assets/v2/image-center.png')" style="width: 74px;height: 74px;position: relative;z-index: 2">
      </div>
    </el-upload>

</template>

<script>
    import {getToken} from "@/utils/auth";
    import axios from 'axios';

    export default {
        name: "index",
        props: {
            limit: {
                type: Number,
                default:10
            },
            value:{},
            merchantIMG:false,
            type:{
                default: 1//1-默认 2-身份证正面 3-身份证反面
            }
        },
        watch:{
            value:{
                immediate:true,
                handler:function(value){
                    if(!value){
                        this.fileList=[];
                        this.imagesUrl="";
                        return;
                    }

                    this.fileList=[{uid:"1",url:value}];
                    this.imagesUrl=value;
                }
            },
        },
        computed: {
            headers() {
                return {
                    "access-token": this.token // 直接从本地获取token就行
                };
            },

        },
        data() {
            return {token: getToken(), dialogVisible: false,imagesUrl:"",fileList:[]}
        },

        methods: {
            imgurl() {
                return axios.defaults.baseURL + "/common/updateLoad";
            },

            handleSuccess(res, file) {
                // debugger
                this.imagesUrl=res.data;
                this.$emit("input",this.imagesUrl)
                // console.log(res);
                // console.log(file);
                //   this.personage.identityFront = res.data;
            },



            // 图片格式要求
            beforeAvatarUpload(file) {
                console.log(this.merchantIMG)
                if(this.merchantIMG){
                    const isPNG = file.type === "image/png";
                    const isJPG = file.type === "image/jpeg";
                    const isBMP = file.type === "image/bmp";
                    const isLt10M = file.size / 1024 / 1024 / 10;

                    if (!isPNG && !isJPG && !isBMP) {
                        this.$message.error("支持JPEG,JPG,BMP等图片格式!");
                    }
                    if (!isLt10M) {
                        this.$message.error("上传图片最大不超10M！");
                    }
                    return isBMP || isPNG || (isJPG && isLt10M);
                }else{
                    const isPNG = file.type === "image/png";
                    const isJPG = file.type === "image/jpeg";
                    const isLt2M = file.size / 1024 / 1024 < 2;

                    if (!isPNG && !isJPG) {
                        this.$message.error("上传图片只能是 JPG 格式和PNG格式!");
                    }
                    if (!isLt2M) {
                        this.$message.error("上传图片大小不能超过 2MB!");
                    }
                    return isPNG || (isJPG && isLt2M);
                }

            }
        }
    }
</script>

<style scoped>
   .bg{
     width: 380px;
     height: 214px;
     background: #F1F2F6;
     border-radius: 8px;
     display: flex;
     justify-content: center;
     align-items: center;
     position: relative;
   }
   .bg-image{
     position: absolute;
     left: 0px;
     top: 0px;
   }
  .avatar-uploader {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar {
    width: 380px;
    height: calc(214px - 2px);
    display: block;
    border-radius: 6px;
    border: 1px dashed #d9d9d9;
  }
</style>



// WEBPACK FOOTER //
// src/components/FSingleImageUpload/index.vue